import { useState } from 'react'
import { client } from '@lib/api'

const normalizePhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters
  let cleaned = phoneNumber.replace(/\D/g, '')

  // For Indonesian numbers (country code 62), convert to 0-prefixed format
  if (cleaned.startsWith('62')) {
    cleaned = '0' + cleaned.substring(2)
  } else if (cleaned.startsWith('0')) {
    // Already has 0 prefix (Indonesian format), keep as is
    return cleaned
  } else {
    // For other countries or formats without prefix, assume Indonesian and add 0
    cleaned = '0' + cleaned
  }

  return cleaned
}

type ValidationResult = {
  success: boolean
  providerId?: string
  providerName?: string
  providerImageUrl?: string | null
  error?: string
}

type ValidationResponse = {
  id: string
  name: string
  image_url: string | null
}

export const usePhoneValidation = () => {
  const [isValidating, setIsValidating] = useState(false)

  const validatePhoneNumber = async (phoneNumber: string, service?: string): Promise<ValidationResult> => {
    setIsValidating(true)
    try {
      const normalizedPhone = normalizePhoneNumber(phoneNumber)

      let url =  `/wallet/ppob/mobile-provider/validate?phone_number=${normalizedPhone}`

      if (service) {
        url += `&service_category=${service}`
      }

      const response = await client.doGet<ValidationResponse>(url)


      setIsValidating(false)
      return {
        success: true,
        providerId: response.id,
        providerName: response.name,
        providerImageUrl: response.image_url,
      }
    } catch (err: any) {
      setIsValidating(false)
      return {
        success: false,
        error: err.responseBody?.error?.message || err.message || 'Failed to validate phone number',
      }
    }
  }

  return {
    validatePhoneNumber,
    isValidating,
    normalizePhoneNumber,
  }
}
